import { apiCaller, checkStatusResponse, notifyToast } from "../helpers";
import { setStateAdmin } from "./admins";

const initialState = {
  banners: [],
  isBanner: false,
  linkPage: {},
  isLinkPage: false,
  contacts: {},
  royalties: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_STATE_SETTING":
      return Object.assign({}, state, {
        [action.propertyName]: action.value,
      });
    case "SET_MULTIPLE_STATE_SETTING":
      return Object.assign({}, state, action.newObject);
    default:
      return state;
  }
}

// set state dashboard
export function setStateSetting(propertyName, value) {
  return {
    type: "SET_STATE_SETTING",
    propertyName,
    value,
  };
}

// set multi dashboard
export function setMultipleStateSetting(newObject) {
  return {
    type: "SET_MULTIPLE_STATE_SETTING",
    newObject,
  };
}

// Banner
export function getAllBanner(page, pageSize, langId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/banner/getallbanner?queryString=null&pageIndex=${page}&pageSize=${pageSize}&langId=${langId}`,
        "GET",
        null
      );
      console.log(res);
      const { response } = res.data;
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateSetting("banners", response));
      dispatch(setStateSetting("isBanner", false));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function deleteBanner(bannerId, langId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/banner/deletebanner?bannerId=${bannerId}&langId=${langId}`,
        "DELETE",
        null
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Xóa banner thành công!");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function createBanner(body) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(`/api/banner/addbanner`, "POST", body);
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateSetting("isBanner", true));
      notifyToast("success", "Tạo banner thành công!");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function detailBanner(bannerId, langId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/banner/getcategorybyid?bannerId=${bannerId}&langId=${langId}`,
        "GET",
        null
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function updateBanner(body) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(`/api/banner/updatebanner`, "PUT", body);
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateSetting("isBanner", true));
      notifyToast("success", "Cập nhật banner thành công!");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

// link page
export function getLinkPage(page, pageSize, query) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/linkwebsite/getalllinkwebsite?queryString=${query}&pageIndex=${page}&pageSize=${pageSize}`,
        "GET",
        null
      );
      console.log(res);
      const { response } = res.data;
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateSetting("linkPage", response));
      dispatch(
        setMultipleStateSetting({
          linkPage: response,
          isLinkPage: false,
        })
      );
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}
export function addLinkPage(body) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/linkwebsite/addlinkwebsite`,
        "POST",
        body
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Tạo mới thành công");
      dispatch(setStateSetting("isLinkPage", true));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}
export function updateLinkPage(body) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/linkwebsite/updatelinkwebsite`,
        "PUT",
        body
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Cập nhật thành công");
      // dispatch(setStateSetting("isLinkPage", true));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}
export function deleteLinkPage(id) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/linkwebsite/deletelinkwebsite?id=${id}`,
        "DELETE",
        null
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Xóa liên kết thành công");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

// contact
export function getContact(page, pageSize, query, fromDate, toDate) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/contact/getallcontact?pageIndex=${page}&pageSize=${pageSize}&name=${query}&fromDate=${fromDate}&toDate=${toDate}`
      );
      console.log(res);
      const { response } = res.data;
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateSetting("contacts", response));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function deleteContact(id) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/contact/deletecontact?id=${id}`,
        "DELETE",
        null
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Xóa liên hệ thành công");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function getRoyalties(
  queryString,
  page,
  pageSize,
  fromDate,
  toDate,
  status
) {
  return async (dispatch) => {
    let url =
      status !== null
        ? `/api/royalties?queryString=${
            queryString === null ? "" : queryString
          }&pageIndex=${page}&pageSize=${pageSize}&fromDate=${fromDate}&endDate=${toDate}&status=${status}`
        : `/api/royalties?queryString=${
            queryString === null ? "" : queryString
          }&pageIndex=${page}&pageSize=${pageSize}&fromDate=${fromDate}&endDate=${toDate}`;
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(url);
      const { response } = res.data;
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateSetting("royalties", response));
    } catch (error) {
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}
